import * as React from 'react';
import { Route } from 'react-router';
import Layout from './components/wrapper/Layout';
import themePrimary from './styles/themePrimary';
import './custom.css'
import './fonts/LeagueSpartan-Bold.ttf';
import './fonts/LeagueSpartan-Regular.ttf';
import { ThemeProvider, CssBaseline, makeStyles } from '@material-ui/core';
import SystemOffline from './components/checkout/SystemOffline';
import DemoQR from './components/checkout/DemoQR';
import CheckOut from './components/checkout/CheckOut';
import Check from './components/checkout/Check';
import Split from './components/checkout/Split';
import UserStateContextProvider from './providers/UserStateContextProvider';
import PayCheck from './components/payment/PayCheck';
import CheckOutComplete from './components/postcheckout/CheckOutComplete';
import ReviewChecks from './components/postcheckout/ReviewChecks';
import ViewReceipt from './components/postcheckout/ViewReceipt';
import EmailViewReceipt from './components/receipt/EmailViewReceipt';
import StripePaymentCallback from './components/payment/StripePaymentCallback';
import MultipleChecks from './components/checkout/MultipleChecks';
import './styles/common.css';
import CheckOutStateContextProvider from './providers/CheckOutStateContextProvider';
import CheckStateContextProvider from './providers/CheckStateContextProvider';
import { CookiesProvider } from "react-cookie";
import Test from './components/checkout/Test';
import GlobalPayPaymentCallback from './components/payment/GlobalPayPaymentCallback';
import FreedomPayPaymentCallback from './components/payment/FreedomPayPaymentCallback';
import NoReceipt from './components/postcheckout/NoReceipt';

const useStyles = makeStyles({
    root: {
        overflow: 'hidden',
        fontFamily: 'LeagueSpartan-Bold !important',
        backgroundColor: themePrimary.palette.primary.contrastText + ' !important',
    }
});

export default () => (
    <div className={useStyles().root}>
        
        <Route path='/demo' component={DemoQR} />
        <CssBaseline />
        <CookiesProvider>
            <ThemeProvider theme={themePrimary}>
                <UserStateContextProvider>
                    <CheckOutStateContextProvider>
                            <Layout>
                            <Route path='/checkout/test' component={Test} />
                                <Route path='/checkout/checkout' component={CheckOut} />
                                <Route path='/checkout/multiplechecks' component={MultipleChecks} />
                                <CheckStateContextProvider>
                                    <Route path='/checkout/check' component={Check} />
                                    <Route path='/checkout/split' component={Split}  />
                                    <Route path='/payment/pay' component={PayCheck}  />
                                    <Route path='/payment/stripecomplete' component={StripePaymentCallback} />
                                    <Route path='/payment/globalpaycomplete' component={GlobalPayPaymentCallback} />
                                    <Route path='/payment/freedompaycomplete' component={FreedomPayPaymentCallback} />
                                    <Route path='/postcheckout/review' component={ReviewChecks} />
                                    <Route path='/postcheckout/receipt' component={ViewReceipt} />
                                    <Route path='/postcheckout/noreceipt' component={NoReceipt} />
                                    <Route path='/postcheckout/checkoutcomplete' component={CheckOutComplete} />
                                    <Route path='/receipt' component={EmailViewReceipt} />
                                    <Route path='/offline' component={SystemOffline} />
                                </CheckStateContextProvider>
                                <Route path='/website' component={() => { 
                                    window.location.href = 'https://checkpls.io/'; 
                                    return null;
                                }}/>
                            </Layout>
                            
                    </CheckOutStateContextProvider>
                </UserStateContextProvider>
            </ThemeProvider>
        </CookiesProvider>
    </div>
);
